// client/src/components/utils/GoalLevelDisplay.js
import React from 'react';
import { Paper, Typography, Chip, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import GoalLevelUtils from 'utils/GoalLevelUtils';

function GoalLevelDisplay({ patientDob }) {
    const theme = useTheme();

    if (!patientDob) return null;
    const goalLevel = GoalLevelUtils.getGoalLevel(patientDob);

    return (
        <Paper elevation={1} sx={{ p: 2, mb: 2, backgroundColor: theme.palette.background.paper }}>
            <Stack direction="row" spacing={3} alignItems="center">
                <div>
                    <Typography variant="subtitle2" color="text.secondary" fontWeight="bold">
                        Goal Level
                    </Typography>
                    <Chip
                        color="success"
                        label={`Level ${goalLevel.level}`}
                        size="medium"
                        sx={{ fontWeight: 'bold' }}
                    />
                </div>
            </Stack>
        </Paper>
    );
}

export default GoalLevelDisplay;